<template>
  <div class="text-center">
    <v-dialog v-model="visible" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p class="text-center pt-3">{{ $t("pleaseWait") }}</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogWaiting",
  data() {
    return {
      visible: false,
    };
  },
  methods:{
    show(){
      this.visible = true
    },
    hide(){
      this.visible = false
    }
  }
};
</script>

<style>
</style>
